import { render, staticRenderFns } from "./message-alert.vue?vue&type=template&id=fc998cf6&scoped=true&"
import script from "./message-alert.vue?vue&type=script&lang=js&"
export * from "./message-alert.vue?vue&type=script&lang=js&"
import style0 from "./message-alert.vue?vue&type=style&index=0&id=fc998cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc998cf6",
  null
  
)

export default component.exports